import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'lisDisplayPipe',
    standalone: false
})
export class LisRatesDisplayPipe implements PipeTransform {
    constructor(private currencyPipe: CurrencyPipe) {

    }

    transform(value: string): string {
        if (isNaN(+value)) {
            return value;
        }

        return this.currencyPipe.transform(value);
    }
}